import { useHistory } from "react-router-dom";
import { AuthUIWrapper } from "components/Auth/AuthUIWrapper";
import { Button } from "components/DesignSystem/Button/Button";
import { MCP_NEXT_URL } from "constants/storageKeys";
import { Info } from "components/icons/Info";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const MCPConfirmPage = () => {
  const history = useHistory();
  // const { isCustomer } = useRoleBasedView();

  const rawNext = new URLSearchParams(window.location.search).get("next");
  const nextUrl = rawNext
    ? decodeURIComponent(rawNext)
    : localStorage.getItem(MCP_NEXT_URL);

  const buildAuthorizeUrl = () => {
    const authTokens = localStorage.getItem("authTokens");
    const accessToken = authTokens ? JSON.parse(authTokens).access : null;
    const url = new URL(nextUrl!);
    if (accessToken) {
      url.searchParams.set("access_token", accessToken);
    }
    return url.toString();
  };

  const handleAllowAccess = () => {
    localStorage.removeItem(MCP_NEXT_URL);
    window.location.href = buildAuthorizeUrl();
  };

  const handleContinueWithInkle = () => {
    localStorage.removeItem(MCP_NEXT_URL);
    fetch(buildAuthorizeUrl(), { method: "GET", credentials: "include" }).catch(
      () => {}
    );
    history.push("/");
  };

  return (
    <AuthUIWrapper isSignin>
      <div className="t-flex t-flex-col  t-mt-[72px] sm:t-mt-0">
        <div className="t-flex t-flex-col t-gap-2">
          <div className="t-text-subtitle-lg t-text-text-100">
            Connect to Inkle
          </div>
          <div className="t-text-body-sm t-text-text-30">
            An external tool is requesting read-only access to your Inkle
            account.
          </div>
        </div>

        <div className="t-flex t-flex-col t-gap-3 t-mt-8">
          <Button
            block
            customType="primary"
            size="large"
            onClick={handleAllowAccess}
          >
            Allow access
          </Button>
          <Button
            block
            customType="secondary"
            size="large"
            onClick={handleContinueWithInkle}
          >
            Continue with Inkle
          </Button>
        </div>

        <div className="t-text-body-sm-italic t-italic t-text-neutral-30 t-flex t-items-center t-gap-1 t-mt-5">
          <div className="t-flex t-items-center">
            <Info />
          </div>
          You can revoke access anytime from your connected tool's settings.
        </div>
      </div>
    </AuthUIWrapper>
  );
};
